import React from "react";
import { Box, Typography, Divider, Pagination, colors, Skeleton } from "@mui/material";
import { CardsWrapper } from "./styles";

import { TRANSACTION_TYPE } from "../../../../constants";

import { formatDate } from "../../../../utils/formatDate";

import { formatCurrency } from "../../../../utils/formatCurrency";
import { Transaction } from "../../../../store/services/transactions/dto/transactions.dto";
import { StyleCircle } from "../../../../Components/Inputs/Settings/styles";
import { TRANSACTION_TYPE_ENUM } from "../../../../store/services/invitations/dto/invitations.dto";

const TRANSACTION_TYPE_COLOR: Record<TRANSACTION_TYPE_ENUM, string> = {
	[TRANSACTION_TYPE_ENUM.PAYMENT]: colors.green[500],
	[TRANSACTION_TYPE_ENUM.REFUND]: colors.red[500]
};

const TransactionCardSkeleton = () => (
	<Box className={"card"}>
		<Box my={1} display={"flex"} justifyContent={"space-between"} alignItems={"center"} px={1}>
			<Skeleton width={160} height={20} />
			<Skeleton width={80} height={20} />
		</Box>
		<Divider />
		<Box p={1} pb={0} display={"flex"} flexDirection={"column"} gap={1}>
			<Box display={"flex"} justifyContent={"space-between"}>
				<Skeleton width={80} height={40} />
				<Skeleton width={80} height={40} />
			</Box>
			<Divider />
			<Skeleton width={"70%"} height={20} />
			<Divider />
			<Skeleton width={100} height={20} />
		</Box>
	</Box>
);

const TransactionsCardsList = ({
	data,
	page,
	perPage,
	totalItems,
	onPageChange,
	isLoading
}: {
	data: Transaction[];
	page: number;
	perPage: number;
	totalItems: number;
	onPageChange: (page: number) => void;
	isLoading?: boolean;
}) => {
	if (isLoading) {
		return (
			<CardsWrapper>
				{Array.from({ length: 4 }).map((_, i) => (
					<TransactionCardSkeleton key={i} />
				))}
			</CardsWrapper>
		);
	}

	return (
		<CardsWrapper>
			{(data || []).map(item => (
				<Box key={item.user_id} className={"card"}>
					<Box my={1} display={"flex"} justifyContent={"space-between"} alignItems={"center"} px={1}>
						<Typography fontWeight={"bold"}>Trnx Id: {item.transactionId}</Typography>
						<Box display={"flex"} gap={1} alignItems={"center"}>
							<StyleCircle $color={TRANSACTION_TYPE_COLOR[item.type || 1]} />
							<Typography variant={"caption"}>{TRANSACTION_TYPE[item.type]}</Typography>
						</Box>
					</Box>
					<Divider />
					<Box p={1} pb={0} display={"flex"} flexDirection={"column"} gap={1}>
						<Box display={"flex"} justifyContent={"space-between"} alignItems={"center"}>
							<Box display={"flex"} flexDirection={"column"} alignItems={"flex-start"} gap={1}>
								<Typography fontWeight={"bold"}>Order Id</Typography>
								<Typography>{item.orderId}</Typography>
							</Box>
							<Box display={"flex"} flexDirection={"column"} alignItems={"flex-start"} gap={1}>
								<Typography fontWeight={"bold"}>amount</Typography>
								<Typography>{formatCurrency(item.amount, item.currency)}</Typography>
							</Box>
						</Box>
						<Divider />
						<Box display={"flex"} flexDirection={"column"}>
							<Typography>Invitation Id:</Typography>
							<Box display={"flex"} gap={1}>
								<Typography>{item.invitation_id}</Typography>
							</Box>
						</Box>
						<Divider />
						<Box className={"card-footer"}>
							<Typography>{formatDate(item.createdAt, "Africa/Cairo", "PP")}</Typography>
						</Box>
					</Box>
				</Box>
			))}
			{!!(page && perPage && totalItems) && (
				<Box p={2} display={"flex"} justifyContent={"flex-end"}>
					<Pagination
						page={page}
						count={Math.ceil(totalItems / perPage)}
						shape="rounded"
						onChange={(event: unknown, newPage: number) => {
							onPageChange(newPage);
						}}
					/>
				</Box>
			)}
		</CardsWrapper>
	);
};

export default TransactionsCardsList;
